export default __webpack_public_path__ + "static/gallery2-f90a1708238874f2dffc5c3a79e9b329.png";